import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const LEFT_SIDE_WIDTH = 40;
const RIGHT_SIDE_WIDTH = 130;

interface MultimediaToolbarStyledProps {
  isSelected: boolean;
}

export const useStyles = makeStyles<Theme, MultimediaToolbarStyledProps>(
  (theme) => ({
    accordionDetails: {
      backgroundColor: theme.palette.grey[200],
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px',
      padding: 0,
    },
    accordionSummary: {
      display: 'inline-flex',
      left: `calc(${LEFT_SIDE_WIDTH}px + ${theme.spacing(3)})`,
      padding: 0,
      right: `calc(${RIGHT_SIDE_WIDTH}px + ${theme.spacing(2)})`,

      '& > div:first-child': {
        margin: theme.spacing(2, 1, 2, 0),
      },
    },
    buttonColor: {
      backgroundColor: theme.palette.primary.main,
    },
    title: {
      marginLeft: ({ isSelected }) => theme.spacing(isSelected ? 1 : 4),
      flex: 1,
    },
    whiteText: {
      color: theme.palette.common.white,
    },
    wrapper: {
      display: 'flex',
      position: 'relative',
      zIndex: 3,
    },
    wrapperAccordion: {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },
    wrapperLeftSide: {
      width: `${LEFT_SIDE_WIDTH}px`,
      zIndex: 2,
    },
    wrapperRightSide: ({ isSelected }) => ({
      flex: '1 auto',
      textAlign: 'right',
      paddingRight: isSelected ? theme.spacing(2) : 0,

      '& button': {
        zIndex: 2,
      },
    }),
    wrapperTitle: {
      alignItems: 'center',
      display: ({ isSelected }) => (isSelected ? 'block' : 'flex'),
      height: '100%',
      position: 'absolute',
      width: '100%',
      zIndex: 1,
    },
  }),
);
